import { Config } from './config.type'
const config: Config  = {
    "build": {
        "host": "https://graphql0.canvasflow.io",
        "subdirectory": "/",
        "website": "",
        "subscriptionUrl": "",
        "assetDirectory": "/",
        "title": "Scuba Diver Magazine",
        "shortTitle": "Scuba Diver Magazine",
        "appKey": "9411a5d8-a9e8-413e-86dc-4664bb67b0c7",
        "language": "en",
        "languages": [
            "en"
        ],
        "about": "<p style=\"margin-bottom: 20px;\">Scuba Diver is an independent publisher of scuba diving magazines in all major English-speaking countries.</p> <p>&copy; 2025 <a href=\"https://www.rorkmedia.com/\" target=\"__blank\">Rork Media Limited</a>. All rights reserved.</p>",
        "buildNumber": 539611,
        "buildDate": "2025-10-16T13:53:10.676Z",
        "version": "2.10.16"
    },
    "app": {
        "contentProtection": false,
        "admin": true,
        "favorite": false,
        "auth": {
            "enabled": true,
            "type": "cognito",
            "config": {
                "host": "https://auth0.scubadivermag.com",
                "clientId": "3t78bpsfkdjhrp01732cj4hkod",
                "customerPortalUrl": null
            }
        },
        "hideNavbarOnScroll": false,
        "installationOption": {
            "enabled": false
        },
        "password": {
            "enabled": false,
            "value": ""
        },
        "template": {
            "type": "basic",
            "config": {
                "sections": true
            }
        },
        "menu": {
            "links": [
                {
                    "title": "Terms of Service",
                    "icon": "",
                    "url": "https://www.scubadivermag.com/terms-conditions/"
                },
                {
                    "title": "Privacy Policy",
                    "icon": "",
                    "url": "https://divernet.com/privacy-policy/"
                }
            ]
        }
    },
    "issue": {
        "contentType": "responsive-replica",
        "lastLocation": {
            "enabled": false
        }
    },
    "analytics": {
        "tealium": {
            "ChannelID": "",
            "pageType": "",
            "pageDetail": "",
            "pageTemplate": "",
            "projectType": "",
            "url": ""
        },
        "google": {
            "trackerID": "",
            "sampleRate": 1
        },
        "ga4": {
            "trackerID": "",
            "sampleRate": 1
        },
        "gtm": {
            "trackerID": ""
        },
        "googleOptimize": {
            "trackerID": ""
        },
        "onetrust": {
            "id": ""
        },
        "caymland": {
            "domain": ""
        },
        "ackee": {
            "domainId": "",
            "server": ""
        },
        "netstats": {
            "trackerID": ""
        },
        "hotjar": {
            "trackerID": ""
        },
        "hubspot": {
            "trackerID": ""
        },
        "ShareThis": {
            "trackerID": ""
        },
        "cookiefirst": {
            "key": ""
        },
        "cookiehub": {
            "trackerID": ""
        },
        "plausible": {
            "domain": "app.scubadivermag.com"
        },
        "matomo": {
            "domain": "https://cdn.matomo.cloud/canvasflow.matomo.cloud/matomo.js"
        }
    }
};
export default config;